import React from 'react';
import Seo from '@/components/Seo';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SectionEyebrow from '@/components/SectionEyebrow';
import BlogCard from '@/components/blog/BlogCard';
import { BLOG_POSTS } from '@/data/blog/posts';
import { stock } from '@/data/stockImages';
import { blogJsonLd, breadcrumb } from '@/lib/blog-structured-data';

/* =====================================================================
   Blog → route: /blog
   Yazı listesi (src/data/blog/posts.js, en yeni en üstte).
   ===================================================================== */

const HERO_IMAGES = [
  stock('qr-menu-el', 'Telefonda açık QR menü'),
  stock('sef', 'Mutfakta tabağı hazırlayan şef'),
  stock('musteri-qr', 'Masada telefonundan menüye bakan müşteri'),
];

const Blog = () => (
  <div className="min-h-screen bg-surface">
    <Seo
      title="Blog — Tilki Otomasyon"
      description="Kafe ve restoran işletmecileri için QR menü, sipariş, stok takibi, maliyet hesabı ve müşteri sadakati üzerine rehber yazılar."
      path="/blog"
      jsonLd={[
        blogJsonLd(BLOG_POSTS),
        breadcrumb([
          { name: 'Ana Sayfa', path: '/' },
          { name: 'Blog', path: '/blog' },
        ]),
      ]}
    />
    <Header />

    <main id="main-content">
      <section className="border-b border-hairline bg-surface-2 py-12 sm:py-16">
        <div className="container mx-auto grid items-center gap-10 px-4 lg:grid-cols-[minmax(0,1fr)_auto]">
          <div className="max-w-2xl">
            <SectionEyebrow className="mb-4">Blog</SectionEyebrow>
            <h1 className="type-display-2 text-balance mb-4">Kafe ve restoran işletmeciliği üzerine yazılar</h1>
            <p className="type-body-lg text-pretty">
              QR menüden stok takibine, maliyet hesabından müşteri sadakatine kadar işletmenizi yönetirken işinize
              yarayacak konular.
            </p>
          </div>
          <div className="hidden gap-3 lg:flex" aria-hidden="true">
            {HERO_IMAGES.map((img, i) => (
              <img
                key={img.src}
                src={img.src}
                width={img.width}
                height={img.height}
                alt=""
                className={`w-40 rounded-2xl border border-hairline object-cover shadow-card ${i === 1 ? 'mt-10' : ''}`}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="container mx-auto px-4 py-12 sm:py-16">
        <ul className="grid gap-4 md:grid-cols-2">
          {BLOG_POSTS.map((post) => (
            <li key={post.slug}>
              <BlogCard post={post} />
            </li>
          ))}
        </ul>
      </section>
    </main>

    <Footer />
  </div>
);

export default Blog;
